import React from "react";
import "./_heading.scss";

import Title from "./../../01-atoms/title/title";
import Description from "./../../01-atoms/description/description";

const Heading = ({ title, description }) => {
  return (
    <div className="wizard__heading">
      <Title text={title} />
      {description && <Description text={description} />}
    </div>
  );
};

export default Heading;
